var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("tracking.tracks_details") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "justify-content-start mb-5" },
                [
                  _c("b-col", { attrs: { sm: "2" } }, [_c("back-button")], 1),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      attrs: { sm: "2" },
                      on: {
                        click: function ($event) {
                          return _vm.getTrack()
                        },
                      },
                    },
                    [
                      _c("b-button", { staticClass: "back-button" }, [
                        _c("i", {
                          staticClass: "fa-solid fa-rotate-right fs-14px",
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.rfrsh")) +
                            "\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.activateSpinner
                ? _c("spinner")
                : _vm.Tracking
                ? [
                    _c(
                      "div",
                      [
                        _vm.flagTOOLBOX && _vm.Tracking.TestCasename
                          ? _c(
                              "form-accordion",
                              {
                                attrs: {
                                  title: _vm.$t("tracking.testcases"),
                                  isTitleUpperCase: false,
                                },
                              },
                              [
                                _c(
                                  "b-row",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "6" },
                                      },
                                      [
                                        _c("b-table", {
                                          staticClass: "table table-striped",
                                          staticStyle: { "margin-bottom": "0" },
                                          attrs: {
                                            "thead-class": "d-none",
                                            fields: _vm.TOOLBOXTableFields,
                                            items:
                                              _vm.TrackingTestCaseTableFormattedData,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "cell(field)",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getFieldTrad(
                                                              data.value
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "cell(value)",
                                                fn: function (data) {
                                                  return [
                                                    data.item.field ===
                                                    "Request1CreationDate"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getDate(
                                                                data.value
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(data.value)
                                                          ),
                                                        ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            357927597
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.flagTOOLBOX
                                ? _vm.$t("tracking.details_request")
                                : _vm.$t("tracking.details"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _vm.flagTOOLBOX
                              ? _c(
                                  "b-row",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "6" },
                                      },
                                      [
                                        _c("b-table", {
                                          staticClass: "table table-striped",
                                          staticStyle: { "margin-bottom": "0" },
                                          attrs: {
                                            "thead-class": "d-none",
                                            fields: _vm.TOOLBOXTableFields,
                                            items:
                                              _vm.TrackingTableFormattedData,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "cell(field)",
                                                fn: function (data) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-weight-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getFieldTrad(
                                                              data.value
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "cell(value)",
                                                fn: function (data) {
                                                  return [
                                                    data.item.field ===
                                                    "Request1CreationDate"
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getDate(
                                                                data.value
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(data.value)
                                                          ),
                                                        ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            357927597
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "b-row",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _vm.Tracking.Provider !== ""
                                          ? _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.provider_ddd"
                                                      )
                                                    : "Provider",
                                                inputValue:
                                                  _vm.Tracking.Provider == 1
                                                    ? "STET"
                                                    : "EBA",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "mb-5",
                                        attrs: { sm: "4" },
                                      },
                                      [
                                        _vm.Tracking.MsgId !== ""
                                          ? _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.message_id_ddd"
                                                      )
                                                    : _vm.$t(
                                                        "tracking.id_track"
                                                      ),
                                                inputValue: _vm.Tracking.MsgId,
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.IBAN !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t("tracking.iban"),
                                                      inputValue:
                                                        _vm.Tracking.IBAN,
                                                    },
                                                  }
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _vm.Tracking.IBAN !== ""
                                              ? _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "administration.country"
                                                      ),
                                                      inputValue:
                                                        _vm.getCountryFromIBAN(
                                                          _vm.Tracking.IBAN
                                                        ),
                                                    },
                                                  }
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.BICFrom != ""
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.bic_from_ddd"
                                                      )
                                                    : _vm.$t(
                                                        "tracking.bic_from"
                                                      ),
                                                inputValue:
                                                  _vm.Tracking.BICFrom,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.BICTo !== ""
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.bic_to_ddd"
                                                      )
                                                    : _vm.$t("tracking.bic_to"),
                                                inputValue: _vm.Tracking.BICTo,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.BICBillable !== "" &&
                                    _vm.Tracking.BICFrom !==
                                      _vm.Tracking.BICBillable &&
                                    _vm.Tracking.BICFrom !== "" &&
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.bic_billable"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.BICBillable,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.FullName !== "" &&
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.name"),
                                                inputValue:
                                                  _vm.Tracking.FullName,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Siren !== "" &&
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.siren"),
                                                inputValue: _vm.Tracking.Siren,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Siret !== "" &&
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.siret"),
                                                inputValue: _vm.Tracking.Siret,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.TVAIntracomm !== "" &&
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.tva_intracomm"
                                                ),
                                                inputValue:
                                                  _vm.Tracking.TVAIntracomm,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.LEI !== "" &&
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.select.identifiers.LEIC.label"
                                                ),
                                                inputValue: _vm.Tracking.LEI,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.EUID !== "" &&
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.select.identifiers.EUID.label"
                                                ),
                                                inputValue: _vm.Tracking.EUID,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.ICQX !== "" &&
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.icqx"),
                                                inputValue: _vm.Tracking.ICQX,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Reference !== "" &&
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.$t("tracking.reference"),
                                                inputValue:
                                                  _vm.Tracking.Reference,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.AdditionalInformation !== "" &&
                                    _vm.type === "DDV"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "tracking.additional_information"
                                                ),
                                                inputValue:
                                                  _vm.Tracking
                                                    .AdditionalInformation,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Request1CreationDate !== ""
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.creation_date_request_1_ddd"
                                                      )
                                                    : _vm.$t(
                                                        "tracking.creation_date_request_1"
                                                      ),
                                                inputValue: _vm.getDate(
                                                  _vm.Tracking
                                                    .Request1CreationDate
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Request2CreationDate !== ""
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.creation_date_request_2_ddd"
                                                      )
                                                    : _vm.$t(
                                                        "tracking.creation_date_request_2"
                                                      ),
                                                inputValue: _vm.getDate(
                                                  _vm.Tracking
                                                    .Request2CreationDate
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Request1CreationDate !== "" &&
                                    _vm.Tracking.CreationDateRp2 !== "" &&
                                    _vm.type === "DDD" &&
                                    _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.response_time_ddd"
                                                      )
                                                    : _vm.$t(
                                                        "common.response_time"
                                                      ),
                                                inputValue: _vm.getDuration(
                                                  _vm.Tracking
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.Tracking.Tracking !== "" &&
                                    _vm.type === "DDD" &&
                                    _vm.flagCACP
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "4" },
                                          },
                                          [
                                            _c("form-read-group-label-input", {
                                              attrs: {
                                                inputLabel:
                                                  _vm.type === "DDD" &&
                                                  _vm.flagCACP
                                                    ? _vm.$t(
                                                        "tracking.technical_code_ddd"
                                                      )
                                                    : _vm.$t(
                                                        "tracking.technical_code"
                                                      ),
                                                inputValue:
                                                  _vm.Tracking
                                                    .TechStatusCode !== ""
                                                    ? _vm.translateTechStatusCode(
                                                        _vm.Tracking
                                                          .TechStatusCode
                                                      )
                                                    : _vm.$t(
                                                        "common.monitoring.success"
                                                      ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("hr", { staticClass: "mx-auto" }),
                        _vm._v(" "),
                        !_vm.flagTOOLBOX ||
                        _vm.TrackingTableRespFormattedData.length
                          ? _c(
                              "form-accordion",
                              {
                                attrs: {
                                  title: _vm.$t("tracking.response"),
                                  isTitleUpperCase: false,
                                },
                              },
                              [
                                _vm.flagTOOLBOX
                                  ? _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "mb-5",
                                            attrs: { sm: "6" },
                                          },
                                          [
                                            _c("b-table", {
                                              staticClass:
                                                "table table-striped",
                                              staticStyle: {
                                                "margin-bottom": "0",
                                              },
                                              attrs: {
                                                "thead-class": "d-none",
                                                fields: _vm.TOOLBOXTableFields,
                                                items:
                                                  _vm.TrackingTableRespFormattedData,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "cell(field)",
                                                    fn: function (data) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "font-weight-bold",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getFieldTrad(
                                                                  data.value
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  {
                                                    key: "cell(value)",
                                                    fn: function (data) {
                                                      return [
                                                        [
                                                          "NameScore",
                                                          "IdScore",
                                                        ].includes(
                                                          data.item.field
                                                        )
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getResultText(
                                                                    data.value
                                                                  )
                                                                )
                                                              ),
                                                            ])
                                                          : data.item.field ===
                                                            "CreationDateRp2"
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getDate(
                                                                    data.value
                                                                  )
                                                                )
                                                              ),
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  data.value
                                                                )
                                                              ),
                                                            ]),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2057252246
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "b-row",
                                      { staticClass: "form-group" },
                                      [
                                        _vm.Tracking.CreationDateRp2 !== ""
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.type === "DDD" &&
                                                        _vm.flagCACP
                                                          ? _vm.$t(
                                                              "tracking.creation_date_response_1_ddd"
                                                            )
                                                          : _vm.$t(
                                                              "tracking.creation_date_response_1"
                                                            ),
                                                      inputValue: _vm.getDate(
                                                        _vm.Tracking
                                                          .CreationDateRp2
                                                      ),
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.Response2CreationDate !==
                                        ""
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.type === "DDD" &&
                                                        _vm.flagCACP
                                                          ? _vm.$t(
                                                              "tracking.creation_date_response_2_ddd"
                                                            )
                                                          : _vm.$t(
                                                              "tracking.creation_date_response_2"
                                                            ),
                                                      inputValue: _vm.getDate(
                                                        _vm.Tracking
                                                          .Response2CreationDate
                                                      ),
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.IdScore &&
                                        _vm.type === "DDV"
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t(
                                                          "tracking.id_score"
                                                        ),
                                                      inputValue:
                                                        _vm.getResultText(
                                                          _vm.Tracking.IdScore
                                                        ),
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.NameScore &&
                                        _vm.type === "DDV"
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.name_score"
                                                      ),
                                                      inputValue:
                                                        _vm.getResultText(
                                                          _vm.Tracking.NameScore
                                                        ),
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.RealName !== "" &&
                                        _vm.type === "DDV"
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t(
                                                          "tracking.real_name"
                                                        ),
                                                      inputValue:
                                                        _vm.Tracking.RealName,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                _vm._v(" "),
                                _vm.type == "DDD" &&
                                (_vm.Tracking.LastName !== "" ||
                                  _vm.Tracking.BirthName !== "" ||
                                  _vm.Tracking.FirstName !== "" ||
                                  _vm.Tracking.MarriedName !== "")
                                  ? _c(
                                      "b-row",
                                      { staticClass: "form-group" },
                                      [
                                        _vm.Tracking.FirstName !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.first_name"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking.FirstName,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.LastName !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t(
                                                          "tracking.last_name"
                                                        ),
                                                      inputValue:
                                                        _vm.Tracking.LastName,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.BirthName !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.birth_name"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking.BirthName,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.MarriedName !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.married_name"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking
                                                          .MarriedName,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.FirstName2 !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.first_name"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking.FirstName2,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.LastName2 !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t(
                                                          "tracking.last_name"
                                                        ),
                                                      inputValue:
                                                        _vm.Tracking.LastName2,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.BirthName2 !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.birth_name"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking.BirthName2,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.MarriedName2 !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.married_name"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking
                                                          .MarriedName2,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.type === "DDD" &&
                                (_vm.Tracking.CompanyName !== "" ||
                                  _vm.Tracking.Siren !== "" ||
                                  _vm.Tracking.Siret !== "" ||
                                  _vm.Tracking.TVAIntracomm !== "")
                                  ? _c(
                                      "b-row",
                                      { staticClass: "form-group" },
                                      [
                                        _vm.Tracking.CompanyName !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.company_name"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking
                                                          .CompanyName,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.TradingName !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "annuaire.trading_name"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking
                                                          .TradingName,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.Siren !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t(
                                                          "tracking.siren"
                                                        ),
                                                      inputValue:
                                                        _vm.Tracking.Siren,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.Siret !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t(
                                                          "tracking.siret"
                                                        ),
                                                      inputValue:
                                                        _vm.Tracking.Siret,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.TVAIntracomm !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.tva_intracomm"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking
                                                          .TVAIntracomm,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.LEI !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.select.identifiers.LEIC.label"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking.LEI,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.EUID !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.select.identifiers.EUID.label"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking.EUID,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.CompanyName2 !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.company_name"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking
                                                          .CompanyName2,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.TradingName2 !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "annuaire.trading_name"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking
                                                          .TradingName2,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.Siren2 !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t(
                                                          "tracking.siren"
                                                        ),
                                                      inputValue:
                                                        _vm.Tracking.Siren2,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.Siret2 !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel:
                                                        _vm.$t(
                                                          "tracking.siret"
                                                        ),
                                                      inputValue:
                                                        _vm.Tracking.Siret2,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.TVAIntracomm2 !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.tva_intracomm"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking
                                                          .TVAIntracomm2,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.LEI2 !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.select.identifiers.LEIC.label"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking.LEI2,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.EUID2 !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.select.identifiers.EUID.label"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking.EUID2,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.type === "DDD" &&
                                _vm.Tracking.Status === "0" &&
                                (_vm.Tracking.ReasonCode !== "" ||
                                  _vm.Tracking.ReasonDescription !== "")
                                  ? _c(
                                      "b-row",
                                      { staticClass: "form-group" },
                                      [
                                        _vm.Tracking.ReasonCode !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.reason_code"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking.ReasonCode,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.Tracking.ReasonDescription !== "" &&
                                        _vm.type === "DDD" &&
                                        !_vm.flagCACP
                                          ? _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-5",
                                                attrs: { sm: "4" },
                                              },
                                              [
                                                _c(
                                                  "form-read-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "tracking.reason_description"
                                                      ),
                                                      inputValue:
                                                        _vm.Tracking
                                                          .ReasonDescription,
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr", { staticClass: "mx-auto" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t("tracking.history"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _c(
                              "b-row",
                              {
                                staticClass:
                                  "mb-3 justify-content-start ml-3 mr-3",
                              },
                              [
                                _vm.Tracking.History &&
                                _vm.Tracking.History.length
                                  ? _c("b-table", {
                                      staticClass: "table table-striped",
                                      attrs: {
                                        responsive: "",
                                        fields: _vm.fieldsTrackingHistory,
                                        items: _vm.Tracking.History,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "cell(status)",
                                            fn: function (data) {
                                              return [
                                                data.item.Status !== ""
                                                  ? _c("div", [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "tracking.status-" +
                                                                data.item.Status
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(statusCode)",
                                            fn: function (data) {
                                              return [
                                                data.item.StatusCode !== ""
                                                  ? _c("div", [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            _vm.translateTechStatusCode(
                                                              data.item
                                                                .StatusCode
                                                            )
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(processingDate)",
                                            fn: function (data) {
                                              return [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.getDate(
                                                        data.item.DateTime
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(buttons)",
                                            fn: function (data) {
                                              return [
                                                [
                                                  "1",
                                                  "5",
                                                  "8",
                                                  "10",
                                                  "30",
                                                  "45",
                                                  "50",
                                                  "100",
                                                  "110",
                                                  "125",
                                                  "160",
                                                ].includes(data.item.Status) &&
                                                data.item.IdMsg
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex justify-content-center align-item-center",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-eye px-1 cursor-pointer",
                                                          staticStyle: {
                                                            color:
                                                              "var(--actionButtonColorBlue)",
                                                            "font-size": "15px",
                                                          },
                                                          attrs: {
                                                            title: "Open",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.seeJson(
                                                                data.item.IdMsg,
                                                                data.item
                                                                  .Status,
                                                                "historyTracking",
                                                                "see"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("i", {
                                                          staticClass:
                                                            "fas fa-download px-1 cursor-pointer",
                                                          staticStyle: {
                                                            color:
                                                              "var(--actionButtonColorBlue)",
                                                            "font-size": "15px",
                                                          },
                                                          attrs: {
                                                            title: "Download",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.seeJson(
                                                                data.item.IdMsg,
                                                                data.item
                                                                  .Status,
                                                                "historyTracking",
                                                                "download"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2417844816
                                      ),
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }